<template>
  <div>
    <div  class="actionForm">
      <template v-for="conf in configs" v-if="(conf.configId == $route.params.id) || ($route.params.id == 'tmp')">
        <h2>Download <span class="lowerCase">postgresql.conf</span> File <span class="configName"> — {{ conf.name }}</span></h2>

        <div class="form">
          <p class="formInfo">Please select the file type you want to download.</p>

          <hr/>

          <div class="selectBg">
            <select class="downloadOptions" v-model="fileType" @change="getDownloadLink()" title="Select File Type">
              <option value="" selected disabled>Select file type</option>
              <option>default</option>
              <option>minified</option>
              <option>alter_system</option>
              <option>json</option>
              <option>yaml</option>
              <option>stackgres</option>
              <option>original</option>
            </select>
          </div>

          <span class="warning" style="display: none"><p>There was an error trying to download your configuration. {{ downloadError }}</p></span>

        </div>

        <div class="fileContent" v-if="file.length">
          <textarea v-model="rawFile" class="hidden" id="configData"></textarea>
          <pre :class="fileType">
            <div class="loader"></div>
            <span class="copied" style="display: none"><strong>Copied to clipboard</strong></span>
            <code :class="['json','yaml'].includes(fileType) ? fileType : 'javascript'" v-html="file"></code>
          </pre>
        </div>

        <div v-if="downloadUrl.length">
          <hr/>
          <a :download="['json','yaml'].includes(fileType) ? parseName(conf.name) + '.' +fileType : parseName(conf.name) + '.conf'" :href="downloadUrl" title="Download File" class="btn download">Download File</a> <button class="copyClipboard btn" @click="copyLink">Copy to Clipboard</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import store from '../store'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'

  // Import language highlighters
  import hljs from 'highlight.js'
  import 'highlight.js/styles/github.css';

  export default {
    name: 'DownloadConfig',

    mixins: [mixin],

    data: function() {
      return {
        fileType: '',
        file: '',
        rawFile: '',
        downloadUrl: '',
        fileName: '',
        isReady: false,
        downloadError: ''
      }
    },

    created: function() {

    },

    computed: {
      configs () {
        const vc = this;

        if( vc.$route.params.id == 'tmp') {
          
          if('tmpConfig' in sessionStorage) {
          
            let tmpConfig = JSON.parse(sessionStorage.tmpConfig)            
            tmpConfig['version'] = tmpConfig.pgVersion
            delete tmpConfig.pgVersion

            store.commit('setConfigs', [tmpConfig])

          }

        } else if ( (vc.$route.name == 'DownloadPublicConfig') && !vc.isReady ) {
            axios
            .get(process.env.VUE_APP_API_URL+'/public/configs/'+vc.$route.params.id)
            .then(function(response){
                vc.pgVersion = response.data.pgVersion
                store.commit('setConfigs', [response.data])
                vc.isReady = true;
            })
            .catch(function(err) {
                if(err.response.status != 401)
                    console.log(err);
            });
        }

        return store.state.configs
      },
    },

    methods: {

      parseJSON(json) {

        const vc = this;

        if(vc.$route.params.id == 'tmp') {
          delete json.name
          delete json.creationDate
          delete json.configId
          delete json.url
        }

        var output = '<span class="symbol">{</span>\n'

        if(json.hasOwnProperty('name'))
          output += ' <span class="key">"name"</span>: <span class="value">"'+json.name+'"</span>,\n'
        
        if(json.hasOwnProperty('configId'))
          output += ' <span class="key">"configId"</span>: <span class="value">"'+json.configId+'"</span>,\n'
        
        if(json.hasOwnProperty('url'))
          output += ' <span class="key">"url"</span>: <span class="value">"'+json.url+'"</span>,\n'
        
        if(json.hasOwnProperty('creationDate'))
          output += ' <span class="key">"creationDate"</span>: <span class="value">"'+json.creationDate+'"</span>,\n'
        
        if(json.hasOwnProperty('lastEditedDate'))
          output += ' <span class="key">"lastEditedDate"</span>: <span class="value">"'+json.lastEditedDate+'"</span>,\n'

        output += ' <span class="key">"files"</span>: <span class="symbol">{</span>\n'
        output += '   <span class="key">"postgresql.conf"</span>: <span class="symbol">[</span>\n'
        json.files['postgresql.conf'].forEach( function(item, index) {
          output += '    <span class="symbol">{</span>\n'
          output += item.hasOwnProperty('comment') ? '     <span class="key">"comment"</span>: <span class="value">"'+item.comment.trim().replace(/\n$/, "")+'"</span>,\n' : ''
          output += '      <span class="key">"name"</span>: <span class="value">"'+item.name+'"</span>,\n'
          output += '      <span class="key">"setting"</span>: <span class="value">"'+item.setting+'"</span>,\n'
          output += (index < (json.files['postgresql.conf'].length - 1)) ? '    <span class="symbol">}</span>,\n' : '    <span class="symbol">}</span>\n'
        });
        output += '  <span class="symbol">]</span>\n'
        output += ' <span class="symbol">}</span>\n'

        output += '<span class="symbol">}</span>'
        return output
      },

      processDownload( response ) {
        const vc = this

        if(response.data) {
          $('.warning').fadeOut()
          vc.rawFile = (vc.fileType == 'json') ? JSON.stringify(response.data) : response.data
          vc.file = (vc.fileType == 'json') ? vc.parseJSON(response.data) : hljs.highlightAuto(response.data).value

          // Create blob from response.
          var blob = new Blob(
            [ (vc.fileType == 'json') ? JSON.stringify(response.data, undefined, 2) : response.data ],
            {
              type : "text/plain;charset=utf-8"
            }
          );

          if(['json','yaml'].includes(vc.fileType))
            vc.fileName +=  '.'+vc.fileType
          else if(['default','minified','original'].includes(vc.fileType))
            vc.fileName += '.conf'
          else if(['stackgres'].includes(vc.fileType))
            vc.fileName += '.yaml'

          if ( vc.downloadUrl )
            URL.revokeObjectURL( vc.downloadUrl )

          vc.downloadUrl = URL.createObjectURL( blob );
        } else
          vc.popUp('Warning', '<p>Your configuration contains no params,</br>your download request cannot be processed</p>')
      },

      getDownloadLink() {
        let vc = this

        $('.fileContent .loader').fadeIn();

        if( vc.$route.params.id == 'tmp') {

          let tmpConfig = JSON.parse(sessionStorage.tmpConfig)

          axios
          .post(process.env.VUE_APP_API_URL + '/validate/postgresql.conf/export?format=' + vc.fileType, { version: tmpConfig.pgVersion, params: tmpConfig.params })
          .then( function(response) {
            vc.processDownload(response)
          }).catch(function(err) {
            if(err.response.data.hasOwnProperty('detail'))
              vc.downloadError = err.response.data.detail
            
            $('.warning').fadeIn()
            console.log(err);
          })  

        } else {
          axios.get(process.env.VUE_APP_API_URL + ( (vc.$route.name == 'DownloadPublicConfig') ? '/public' : '' ) + '/configs/' + vc.$route.params.id + '/postgresql.conf/export?format=' + vc.fileType, {
            headers: {
              'Authorization': 'Bearer '+store.state.authToken
            }
          })
          .then( function(response) {
            vc.processDownload(response)
          }).catch(function(err) {
            if(err.response.data.hasOwnProperty('detail'))
              vc.downloadError = err.response.data.detail
            
            $('.warning').fadeIn()
            console.log(err);
          })  
        }

        setTimeout(function(){
          $('.fileContent .loader').fadeOut();
        },2000)
      },

      copyLink() {
        var link = document.getElementById('configData')
        link.select()
        document.execCommand("copy")
        link.blur()
        $('span.copied').fadeIn();

        setTimeout(function(){
          $('span.copied').fadeOut();
        },2000)
      },

      parseName(name) {

        if (!Date.prototype.toISODate) {
          Date.prototype.toISODate = function() {
            return this.getFullYear() + '-' +
                  ('0'+ (this.getMonth()+1)).slice(-2) + '-' +
                  ('0'+ this.getDate()).slice(-2) + 'T' +
                  this.getHours() +
                  this.getMinutes() +
                  this.getSeconds();
          }
        }

        var date = new Date().toISODate();

        return name
        .replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-')
        + '-' + date
        ;
      }

    },
    mounted: function() {
      const vc = this;

      if( (vc.$route.params.id == 'tmp') && !('tmpConfig' in sessionStorage) ) {
        vc.notify('<p>Your request could not be processed, no configuration has been found.<br/><br/><a href="/manage" title="Back to Homepage">Back to Homepage</a></p>', false, 'error')
      }
    }
  }
</script>


<style>
  

  code span.hljs-built_in {
    color: inherit !important;
  }

  code span.symbol {
    color: #0086b3;
  }

  code span.value {
    color: #d14;
  }

  code span.key {
    color: #fff;
  }
</style>
